"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserGuidCookie = exports.setCookies = exports.setRequestCookies = exports.setResponseCookies = exports.parseCookies = exports.USER_GUID_COOKIE_EXPIRY_TIME = exports.USER_GUID_COOKIE = void 0;
const cookie_1 = require("cookie");
const uuid_1 = require("uuid");
exports.USER_GUID_COOKIE = 'UserGuid';
exports.USER_GUID_COOKIE_EXPIRY_TIME = 7776000;
const parseCookies = (cookie = '', decode = true) => (0, cookie_1.parse)(cookie, Object.assign({}, (!decode && {
    decode: (value) => value,
})));
exports.parseCookies = parseCookies;
const setResponseCookies = (response, cookies) => {
    const serializedCookies = cookies.map(({ name, value, maxAge, expires }) => {
        const stringValue = typeof value === 'object' ? `j: ${JSON.stringify(value)}` : String(value);
        return (0, cookie_1.serialize)(name, String(stringValue), {
            maxAge,
            expires,
            path: '/',
        });
    });
    response.setHeader('set-cookie', serializedCookies);
};
exports.setResponseCookies = setResponseCookies;
const setRequestCookies = (request, cookies) => {
    const requestCookies = (0, exports.parseCookies)(request === null || request === void 0 ? void 0 : request.headers.cookie, false);
    const cookieDictionary = cookies.reduce((acc, curr) => {
        const { name: key, value } = curr;
        acc[key] = value;
        return acc;
    }, {});
    const allCookies = Object.assign(Object.assign({}, requestCookies), cookieDictionary);
    const cookiesString = Object.entries(allCookies)
        .map(([key, value]) => `${key}=${value}`)
        .join('; ');
    request.headers.cookie = cookiesString;
};
exports.setRequestCookies = setRequestCookies;
const setCookies = (request, response, cookies) => {
    (0, exports.setRequestCookies)(request, cookies);
    (0, exports.setResponseCookies)(response, cookies);
};
exports.setCookies = setCookies;
const getUserGuidCookie = (request) => {
    var _a;
    const requestCookies = (0, exports.parseCookies)(request === null || request === void 0 ? void 0 : request.headers.cookie);
    const userGuidCookieValue = (_a = requestCookies[exports.USER_GUID_COOKIE]) !== null && _a !== void 0 ? _a : (0, uuid_1.v4)();
    const userGuidCookie = {
        name: exports.USER_GUID_COOKIE,
        value: userGuidCookieValue,
        maxAge: exports.USER_GUID_COOKIE_EXPIRY_TIME,
    };
    return {
        cookies: [userGuidCookie],
    };
};
exports.getUserGuidCookie = getUserGuidCookie;
//# sourceMappingURL=cookiesUtils.js.map